// В.2.e-2: общая утилита прямого уничтожения юнита.
//
// destroyUnit(state, target, ownerIdx, killer=null, killerIdx=null)
//   - Direct kill, игнорирует Иммунитет и Броню.
//   - Не имитирует урон: current.hp = 0, alive = false.
//   - removeFromField (карта уходит в стопку сброса).
//   - dispatchUnitDied срабатывает: Посмертия, on_unit_died-триггеры
//     (Реаниматор, Посмертный контракт, Фудзи и т.д.).
//   - НЕ срабатывает on_damage_taken (это не урон, это destroy).
//
// Используется Вирусом HV-14 («уничтожает выбранного вражеского юнита»)
// и в будущем активкой Зейна / Бьорка по необходимости.

import { dispatchUnitDied } from '../deus/hooks.js';

export function destroyUnit(state, target, ownerIdx, killer = null, killerIdx = null) {
  if (!target) return false;
  if (target.type !== 'unit') return false;
  if (!target.isAlive || !target.isAlive()) return false;
  const owner = state.players?.[ownerIdx];
  if (!owner) return false;
  // Direct kill: не идём через applyDamage, обнуляем hp вручную.
  target.current.hp = 0;
  target.alive = false;
  owner.removeFromField(target);
  state.log?.add(`✗ ${target.name_ru} [${owner.name}] уничтожен`);
  dispatchUnitDied(state, {
    ownerIdx, card: target, killer, killerIdx, killerWasCounter: false
  });
  return true;
}
